<!-- TODO -->
<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<ion-button
  [ngClass]="className"
  [buttonType]="type"
  [fill]="fill"
  [size]="size"
  [color]="color"
  [expand]="expand"
  [shape]="shape"
  [disabled]="disabled"
  (click)="emitClickEvent($event)"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ion-button>
